// ─────────────────────────────────────────────────────────────────────────────
// FlexCases Support Chatbot — chatbot.js
// ─────────────────────────────────────────────────────────────────────────────

const PROXY_URL = "https://flexcases-proxy.flexcasesindia.workers.dev";

// ─── Model Database ───────────────────────────────────────────────────────────
const MODEL_DATA = {
  "Slim Silicone Case": {
    "Apple": ["iPhone 17 Pro Max","iPhone 17 Pro","iPhone 17 Air","iPhone 17","iPhone 16 Pro Max","iPhone 16 Pro","iPhone 16 Plus","iPhone 16 e","iPhone 16","iPhone 15","iPhone 15 plus","iPhone 15 pro","iPhone 15 pro max","iPhone 14","iPhone 14 plus","iPhone 14 pro","iPhone 14 pro max","iPhone 13","iPhone 13 mini","iPhone 13 pro","iPhone 13 pro max","iPhone 12","iPhone 12 mini","iPhone 12 pro","iPhone 12 pro max","iPhone 11","iPhone 11 pro","iPhone 11 pro max","iPhone XS max","iPhone X","iPhone XS","iPhone XR","iPhone SE 2020","iPhone 8 plus","iPhone 8","iPhone 7 plus","iPhone 7"],
    "Samsung": ["Galaxy S26 Ultra","Galaxy S26 Plus","Galaxy S26","Galaxy A12","Galaxy A14 4g","Galaxy A14 5g","Galaxy A15","Galaxy A16 5G","Galaxy A17 5g","Galaxy A22 5g","Galaxy A23 5g","Galaxy A25","Galaxy A26","Galaxy A30S","Galaxy A31","Galaxy A33 5g","Galaxy A34 5g","Galaxy A35","Galaxy A50","Galaxy A51","Galaxy A52","Galaxy A52 5g","Galaxy A52s 5g","Galaxy A53 5g","Galaxy A54 5g","Galaxy A55","Galaxy A73 5g","Galaxy S10 plus","Galaxy S20 fe","Galaxy S20 fe 5g","Galaxy S21","Galaxy S21 plus","Galaxy S21 ultra","Galaxy S21fe","Galaxy S22 5g","Galaxy S22 plus 5g","Galaxy S22 ultra 5g","Galaxy S23","Galaxy S23 FE","Galaxy S23 plus","Galaxy S23 ultra","Galaxy S24","Galaxy S24 FE","Galaxy S24 plus","Galaxy S24 ultra","Galaxy S25","Galaxy S25 +","Galaxy S25 Ultra","Galaxy S25 FE","Galaxy S25 Edge","Galaxy Note 10 lite","Galaxy Note 20 Ultra"],
    "OnePlus": ["OnePlus 15","OnePlus 15R","OnePlus 13","OnePlus 13R","OnePlus 12","OnePlus 12r","OnePlus 11 5G","OnePlus 11R 5G","OnePlus 10 Pro 5G","OnePlus 10T 5G","OnePlus 10R","OnePlus 9RT","OnePlus 9R","OnePlus 9 Pro","OnePlus 9","OnePlus 8T","OnePlus 8 Pro","OnePlus 8","OnePlus 7T Pro","OnePlus 7T","OnePlus 7 Pro","OnePlus 7","OnePlus 6T","OnePlus Nord 5","OnePlus Nord 4","OnePlus Nord 3 5G","OnePlus Nord 2T 5G","OnePlus Nord 2","OnePlus Nord","OnePlus Nord CE 5G","OnePlus Nord CE 2 5G","OnePlus Nord CE 2 Lite 5G","OnePlus Nord CE 3 5G","OnePlus Nord CE 3 Lite 5g","OnePlus Nord CE 4","OnePlus Nord Ce 5","OnePlus Nord CE 4 Lite 5g","OnePlus ACE 2 5G","OnePlus ACE 2V","OnePlus ACE 2","OnePlus ACE"],
    "Vivo": ["Vivo X90 Pro","Vivo X90","Vivo X300","Vivo X200 FE","Vivo X80 Lite","Vivo V70","Vivo V70 FE","Vivo V70 Elite","Vivo V50","Vivo V30","Vivo V29 Pro","Vivo V29e","Vivo V29","Vivo V27 Pro","Vivo V27","Vivo V25 Pro 5G","Vivo V25 5G","Vivo V25e","Vivo V23 Pro 5G","Vivo V23 5G","Vivo V21s","Vivo V21 5G","Vivo V21","Vivo V20 Pro","Vivo T3 5G","Vivo T2 Pro 5G","Vivo T2 5G","Vivo T1 Pro 5G","Vivo T1 5G","Vivo Y300 Plus","Vivo Y300","Vivo Y200","Vivo Y200e","Vivo Y100a","Vivo Y100","Vivo Y75 5G","Vivo Y72 5G","Vivo Y58","Vivo Y56 5G","Vivo Y52 5G","Vivo Y35+ 5G","Vivo Y33S","Vivo Y29 Pro","Vivo Y29","Vivo Y27","Vivo iQOO 12"],
    "Oppo": ["Oppo Reno 14 Pro","Oppo Reno 14","Oppo Reno 12 5g","Oppo Reno 10 Pro Plus 5G","Oppo Reno 10 Pro 5G","Oppo Reno 10 5G","Oppo Reno 8T 5G","Oppo Reno 8 5G","Oppo Reno 7 Pro","Oppo Reno 6 5G","Oppo F31 Pro Plus 5G","Oppo F23 5G","Oppo k13 5G","Oppo A79 5G","Oppo A78 5G","Oppo A74","Oppo A3 Pro 5G","Oppo A58X","Oppo A1 Pro"],
    "Poco": ["Poco C3","Poco C31","Poco C50","Poco C55","Poco F1","Poco F2 Pro","Poco F3 GT 5G","Poco F4 5G","Poco F5 5G","Poco F6","Poco M2","Poco M2 Pro","Poco M3","Poco M3 Pro 5G","Poco M4 5G","Poco M4 Pro 4G","Poco M4 Pro 5G","Poco M5","Poco M6 Pro","Poco X2","Poco X3","Poco X3 Pro","Poco X4 Pro 5G","Poco X5 Pro 5G","Poco X6 5G"],
    "Nothing Phone": ["Nothing Phone 1","Nothing Phone 2","Nothing Phone 2a","Nothing Phone 3","Nothing Phone 3a","Nothing Phone 3a Pro","Nothing CMF Phone 1"],
    "Google": ["Pixel 6","Pixel 6 Pro","Pixel 6a","Pixel 7","Pixel 7 Pro","Pixel 7a","Pixel 8","Pixel 8 Pro","Pixel 8a","Pixel 9","Pixel 9 Pro","Pixel 9 Pro XL","Pixel 10","Pixel 10 Pro","Pixel 10 Pro XL"],
    "iQOO": ["iQOO 7 5G","iQOO 7 Legend 5G","iQOO 9 5G","iQOO 9 Pro","iQOO 9 SE 5G","iQOO 9T 5G","iQOO 11 5G","iQOO 12 5G","iQOO 13","iQOO Z10","iQOO Neo 9 Pro 5G","iQOO Neo 3","iQOO Neo 6 5G","iQOO Neo 7 5G","iQOO Neo 7 Pro 5G","iQOO Z1","iQOO Z3 5G","iQOO Z5 5G","iQOO Z6 5G","iQOO Z6 Lite","iQOO Z6 Pro","iQOO Z6 44W","iQOO Z7 5G","iQOO Z7 Pro","iQOO Z7 S","iQOO Z9 5G","iQOO Z9X"],
    "Realme": ["Realme 7","Realme 7 Pro","Realme 8","Realme 8 5G","Realme 8 Pro","Realme 8s 5G","Realme 9 4G","Realme 9 5G","Realme 9 Pro 5G","Realme 9 Pro Plus 5G","Realme 10 Pro 5G","Realme 10 Pro Plus 5G","Realme 11 5G","Realme 11 Pro","Realme 11 Pro+","Realme 11X 5G","Realme 12 Plus","Realme 12 Pro 5G","Realme 12 Pro Plus","Realme 12 X","Realme 13 Pro Plus","Realme 14 Pro","Realme 14 Pro Plus","Realme 14X","Realme 15","Realme 15 Pro","Realme GT 2","Realme GT 5G","Realme GT 6","Realme GT 7T","Realme GT Neo 2","Realme GT Neo 3","Realme GT Neo Flash","Realme P3 Ultra","Realme Narzo 20 Pro","Realme Narzo 30 5G","Realme Narzo 50 Pro","Realme Narzo 60 Pro","Realme Narzo 60X 5G","Realme V13 5G","Realme X7 Max 5G"],
    "Xiaomi Redmi": ["Xiaomi redmi note 8 pro","Xiaomi redmi note 9 pro","Xiaomi redmi note 10","Xiaomi redmi note 10 pro","Xiaomi redmi note 10 pro max","Xiaomi redmi note 11","Xiaomi redmi note 11 pro","Xiaomi redmi note 12 5g","Xiaomi redmi note 12 pro","Xiaomi redmi note 12 pro plus","Xiaomi redmi note 13","Xiaomi redmi note 13 pro","Xiaomi redmi note 13 pro plus","Xiaomi redmi note 14","Xiaomi redmi note 14 Pro","Xiaomi redmi note 14 Pro Plus","Xiaomi redmi 12 5g","Xiaomi redmi 15 Ultra","Xiaomi mi 11x","Xiaomi mi 11x pro","Xiaomi 11 lite","Xiaomi 11 lite ne 5g","Xiaomi 11i 5g","Xiaomi 11i hypercharge 5g","Xiaomi 12x","Xiaomi 13 pro"],
    "Motorola": ["Motorola Edge 30","Motorola Edge 30 Fusion","Motorola Edge 30 Ultra","Motorola Edge 40","Motorola Edge 40 Neo","Motorola Edge 50","Motorola Edge 50 Fusion","Motorola Edge 60 Pro","Motorola Moto G45 5g","Motorola Moto G54","Motorola Moto G84"],
  },
  "Silicone Case": {
    "Apple": ["iPhone 17 Pro Max","iPhone 17 Pro","iPhone 17 Air","iPhone 17","iPhone 16","iPhone 16e","iPhone 16 Plus","iPhone 16 Pro","iPhone 16 Pro Max","iPhone 15","iPhone 15 plus","iPhone 15 pro","iPhone 15 pro max","iPhone 14","iPhone 14 plus","iPhone 14 pro","iPhone 14 pro max","iPhone 13","iPhone 13 mini","iPhone 13 pro","iPhone 13 pro max","iPhone 12","iPhone 12 mini","iPhone 12 pro","iPhone 12 pro max","iPhone 11","iPhone 11 pro","iPhone 11 pro max","iPhone XS max","iPhone X","iPhone XS","iPhone XR","iPhone SE 2020","iPhone 8 plus","iPhone 8","iPhone 7 plus","iPhone 7"],
    "Samsung": ["Galaxy A03","Galaxy A05S","Galaxy A13 4G","Galaxy A13 5G","Galaxy A14 5g","Galaxy A15 5G","Galaxy A16 5G","Galaxy A17 5G","Galaxy A21s","Galaxy A22 4g","Galaxy A22 5g","Galaxy A23","Galaxy A26","Galaxy A32 4g","Galaxy A32 5g","Galaxy A33 5g","Galaxy A34","Galaxy A35","Galaxy A36 5G","Galaxy A51","Galaxy A52","Galaxy A52 5g","Galaxy A52s 5g","Galaxy A53 5g","Galaxy A54","Galaxy A55","Galaxy A56 5G","Galaxy A71","Galaxy A72","Galaxy A73 5g","Galaxy S21","Galaxy S21 plus","Galaxy S21 ultra","Galaxy S21fe","Galaxy S22 5g","Galaxy S22 plus 5g","Galaxy S22 ultra 5g","Galaxy S23","Galaxy S23 plus","Galaxy S23 ultra","Galaxy S23fe","Galaxy S24","Galaxy S24 FE","Galaxy S24 plus","Galaxy S24 ultra","Galaxy S25","Galaxy S25 Ultra","Galaxy S25 +","Galaxy S25 FE","Galaxy S25 Edge"],
    "OnePlus": ["OnePlus 6","OnePlus 6T","OnePlus 7","OnePlus 7 pro","OnePlus 7T","OnePlus 7T pro","OnePlus 8","OnePlus 8 pro","OnePlus 8T","OnePlus 9","OnePlus 9 Pro","OnePlus 9R","OnePlus 9RT","OnePlus 10 pro 5g","OnePlus 10R","OnePlus 10T 5g","OnePlus 11 5g","OnePlus 11R 5g","OnePlus 12","OnePlus 12R","OnePlus 13","OnePlus 13 R","OnePlus 13S","OnePlus Nord 5","OnePlus Nord 4","OnePlus Nord 3","OnePlus Nord 2T 5g","OnePlus Nord 2","OnePlus Nord","OnePlus Nord CE 2","OnePlus Nord CE 2 lite 5g","OnePlus Nord CE 3 5g","OnePlus Nord CE 3 lite","OnePlus Nord CE 4","OnePlus Nord CE 5g","OnePlus Nord CE4 lite","OnePlus ACE"],
    "Google": ["Pixel 3 XL","Pixel 4","Pixel 4A","Pixel 5","Pixel 6","Pixel 6 pro","Pixel 6A","Pixel 7","Pixel 7 pro","Pixel 7A","Pixel 8","Pixel 8 pro","Pixel 8A","Pixel 9","Pixel 9A","Pixel 9 Pro","Pixel 10","Pixel 10 Pro","Pixel 10 Pro Xl"],
    "Poco": ["Poco C3","Poco C31","Poco C50","Poco C55","Poco F1","Poco F2 Pro","Poco F3 GT 5G","Poco F4 5G","Poco F5 5G","Poco F6","Poco F7","Poco M2","Poco M2 Pro","Poco M3","Poco M3 Pro 5G","Poco M4 5G","Poco M4 Pro 4G","Poco M4 Pro 5G","Poco M5","Poco X2","Poco X3","Poco X3 Pro","Poco X4 Pro 5G","Poco X5 Pro 5G","Poco X6 Pro"],
    "Nothing Phone": ["Nothing Phone 1","Nothing Phone 2","Nothing Phone 2a","Nothing Phone 3","Nothing Phone 3a","Nothing Phone 3a Lite","Nothing Phone 3a Pro","Nothing 4a","Nothing 4a Pro","Nothing CMF Phone 1","Nothing CMF Phone 2 Pro"],
    "Motorola": ["Motorola Edge 30 Pro","Motorola Edge 40","Motorola Edge 40 Neo","Motorola Edge 50","Motorola Edge 50 Fusion","Motorola Edge 50 Neo","Motorola Edge 50 Pro","Motorola Edge 50 Ultra","Motorola Edge 60 Pro","Motorola Edge 60 Stylus","Motorola G73 5G","Motorola G71 5G","Motorola G85 5G","Motorola Moto G13","Motorola Moto G24 Power","Motorola Moto G32","Motorola Moto G34 5G","Motorola Moto G45 5g","Motorola Moto G52","Motorola Moto G60","Motorola Moto G64","Motorola Moto G82 5G","Motorola Moto G84"],
  },
  "Glass Case": {
    "Apple": ["iPhone 6","iPhone 6 plus","iPhone 6s","iPhone 6s plus","iPhone 7","iPhone 7 plus","iPhone 8","iPhone 8 plus","iPhone SE 2020","iPhone X","iPhone XR","iPhone XS","iPhone XS max","iPhone 11","iPhone 11 pro","iPhone 11 pro max","iPhone 12","iPhone 12 mini","iPhone 12 pro","iPhone 12 pro max","iPhone 13","iPhone 13 mini","iPhone 13 pro","iPhone 13 pro max","iPhone 14","iPhone 14 plus","iPhone 14 pro","iPhone 14 pro max","iPhone 15","iPhone 15 plus","iPhone 15 pro","iPhone 15 pro max","iPhone 16","iPhone 16 Plus","iPhone 16e","iPhone 16 pro","iPhone 16 pro max","iPhone 17","iPhone 17 Air","iPhone 17 Pro","iPhone 17 Pro Max"],
    "Samsung": ["Galaxy S8","Galaxy S8 plus","Galaxy S9","Galaxy S9 plus","Galaxy S10","Galaxy S10 lite","Galaxy S10 plus","Galaxy S10e","Galaxy S20","Galaxy S20 fe","Galaxy S20 fe 5g","Galaxy S20 plus","Galaxy S20 ultra","Galaxy S21","Galaxy S21 plus","Galaxy S21 ultra","Galaxy S21fe","Galaxy S22 5g","Galaxy S22 plus 5g","Galaxy S22 ultra 5g","Galaxy S23","Galaxy S23 plus","Galaxy S23 ultra","Galaxy S23fe","Galaxy S24","Galaxy S24 FE","Galaxy S24 plus","Galaxy S24 ultra","Galaxy S25","Galaxy S25 FE","Galaxy S25 Plus","Galaxy S25 Ultra","Galaxy S26","Galaxy S26 Plus","Galaxy S26 Ultra","Galaxy A10","Galaxy A11","Galaxy A12","Galaxy A14 4g","Galaxy A14 5g","Galaxy A15 5g","Galaxy A16 5g","Galaxy A17 5g","Galaxy A22 4g","Galaxy A22 5g","Galaxy A23 5g","Galaxy A25 5g","Galaxy A26","Galaxy A31","Galaxy A32 4g","Galaxy A32 5g","Galaxy A33 5g","Galaxy A34 5g","Galaxy A35","Galaxy A51","Galaxy A52","Galaxy A52 5g","Galaxy A52s 5g","Galaxy A53 5g","Galaxy A54 5g","Galaxy A55","Galaxy A71","Galaxy A72","Galaxy A73 5g","Galaxy Note 9","Galaxy Note 10","Galaxy Note 10 plus","Galaxy Note 20","Galaxy Note 20 ultra","Galaxy Z Fold 3 5G","Galaxy Z Fold 4","Galaxy Z Fold 5","Galaxy Z Flip 3 5G","Galaxy Z Flip 4","Galaxy Z Flip 5"],
    "OnePlus": ["OnePlus 5t","OnePlus 6","OnePlus 6t","OnePlus 7","OnePlus 7 pro","OnePlus 7t","OnePlus 7t pro","OnePlus 8","OnePlus 8 pro","OnePlus 8t","OnePlus 9","OnePlus 9 pro","OnePlus 9r","OnePlus 9rt","OnePlus 10 pro 5g","OnePlus 10r","OnePlus 10t 5g","OnePlus 11 5g","OnePlus 11r 5g","OnePlus 12","OnePlus 12r","OnePlus 13","OnePlus 13R","OnePlus 13S","OnePlus 15","OnePlus 15R","OnePlus Nord 5","OnePlus Nord 4","OnePlus nord 3 5g","OnePlus nord 2t 5g","OnePlus nord 2","OnePlus nord","OnePlus nord ce 5g","OnePlus nord ce 2 5g","OnePlus nord ce 2 lite 5g","OnePlus nord ce 3 5g","OnePlus nord ce 3 lite","OnePlus nord ce 4","OnePlus Nord Ce 5","OnePlus ace 5g","OnePlus ace 2 5g","OnePlus ace pro 5g"],
    "Google": ["Pixel 6","Pixel 6 pro","Pixel 6a","Pixel 7","Pixel 7 pro","Pixel 7a","Pixel 8","Pixel 8 pro","Pixel 8a","Pixel 9","Pixel 9 Pro","Pixel 9 Pro XL","Pixel 10","Pixel 10 Pro","Pixel 10 Pro XL"],
    "Poco": ["Poco C3","Poco C31","Poco C50","Poco C55","Poco F1","Poco F2 Pro","Poco F3 GT 5G","Poco F4 5G","Poco F5 5G","Poco M2","Poco M2 Pro","Poco M3","Poco M3 Pro 5G","Poco M4 5G","Poco M4 Pro 4G","Poco M4 Pro 5G","Poco M5","Poco X2","Poco X3","Poco X3 Pro","Poco X4 Pro 5G","Poco X5 Pro 5G"],
    "Nothing Phone": ["Nothing Phone 1","Nothing Phone 2","Nothing Phone 2a","Nothing Phone 3","Nothing Phone 3a","Nothing Phone 3a Pro","Nothing CMF Phone 1"],
    "Motorola": ["Motorola edge 30","Motorola edge 30 fusion","Motorola edge 30 ultra","Motorola edge 40","Motorola edge 40 neo","Motorola edge 50","Motorola edge 50 fusion","Motorola edge 50 pro","Motorola Edge 60 Fusion","Motorola Edge 60 Pro","Motorola moto g45","Motorola moto g54","Motorola moto g64","Motorola moto g84"],
    "Samsung Fold/Flip": ["Galaxy Z Fold 3 5G Front","Galaxy Z Fold 3 5G Back","Galaxy Z Fold 4 Front","Galaxy Z Fold 4 Back","Galaxy Z Fold 5 Front","Galaxy Z Fold 5 Back","Galaxy Z Flip 3 5G Top","Galaxy Z Flip 3 5G Bottom","Galaxy Z Flip 4 Top","Galaxy Z Flip 4 Bottom","Galaxy Z Flip 5 Top","Galaxy Z Flip 5 Bottom"],
  }
};

function checkModel(query) {
  const q = query.toLowerCase().trim();
  const found = {};
  for (const [caseType, brands] of Object.entries(MODEL_DATA)) {
    for (const [brand, models] of Object.entries(brands)) {
      for (const model of models) {
        if (model.toLowerCase().includes(q) || q.includes(model.toLowerCase())) {
          if (!found[model]) found[model] = [];
          if (!found[model].includes(caseType)) found[model].push(caseType);
        }
      }
    }
  }
  return found;
}

// ─── Styles ───────────────────────────────────────────────────────────────────
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
  #fc-chat-fab {
    position: fixed; bottom: 20px; right: 20px; z-index: 99999;
    width: 52px; height: 52px; border-radius: 15px; border: none;
    background: linear-gradient(135deg, #1a1a1a, #2d2d2d);
    box-shadow: 0 4px 20px rgba(0,0,0,0.35);
    cursor: pointer; font-size: 22px;
    display: flex; align-items: center; justify-content: center;
    animation: fcPulse 2.4s ease-in-out infinite;
    transition: all .2s;
  }
  #fc-chat-fab.open { background: #111; animation: none; box-shadow: 0 4px 16px rgba(0,0,0,.3); }
  @keyframes fcPulse {
    0%,100% { box-shadow: 0 4px 20px rgba(0,0,0,.3); }
    50%      { box-shadow: 0 4px 28px rgba(0,0,0,.5); }
  }
  #fc-chat-window {
    position: fixed; z-index: 99998;
    background: #fff; display: none; flex-direction: column;
    font-family: 'Plus Jakarta Sans', sans-serif;
    overflow: hidden;
    bottom: 82px; right: 20px;
    width: 340px; height: 510px;
    border-radius: 20px;
    box-shadow: 0 16px 50px rgba(0,0,0,.18);
    border: 1px solid rgba(0,0,0,.12);
    animation: fcSlideUp .25s ease;
  }
  #fc-chat-window.open { display: flex; }
  @keyframes fcSlideUp {
    from { opacity:0; transform:scale(.95) translateY(8px); }
    to   { opacity:1; transform:scale(1)  translateY(0);    }
  }
  @media (max-width: 480px) {
    #fc-chat-window {
      bottom: 76px; right: 10px; left: 10px;
      width: auto !important;
      height: 60vh !important;
      max-height: 460px; min-height: 300px;
      border-radius: 16px;
    }
    #fc-chat-fab { bottom: 14px; right: 14px; width: 48px; height: 48px; font-size: 20px; border-radius: 13px; }
  }
  #fc-chat-header {
    background: linear-gradient(135deg, #111111, #222222);
    padding: 13px 16px; display: flex; align-items: center; gap: 10px;
    flex-shrink: 0;
  }
  .fc-avatar {
    width:34px; height:34px; border-radius:10px; flex-shrink:0;
    background: rgba(255,255,255,.12);
    display:flex; align-items:center; justify-content:center; font-size:16px;
  }
  .fc-hdr-title { font-weight:700; color:#fff; font-size:14px; font-family:'Plus Jakarta Sans',sans-serif; }
  .fc-hdr-status { display:flex; align-items:center; gap:5px; margin-top:2px; }
  .fc-dot { width:6px; height:6px; border-radius:50%; background:#6ee7b7; flex-shrink:0; }
  .fc-hdr-status-text { color:rgba(255,255,255,.7); font-size:11px; }
  #fc-chat-close {
    background: rgba(255,255,255,.12); border:none; cursor:pointer;
    width:26px; height:26px; border-radius:7px; color:#fff; font-size:13px;
    display:flex; align-items:center; justify-content:center; margin-left:auto;
  }
  #fc-messages {
    flex:1; overflow-y:auto; padding:12px 11px;
    background:#f8f8f8; display:flex; flex-direction:column; gap:9px;
  }
  #fc-messages::-webkit-scrollbar { width:3px; }
  #fc-messages::-webkit-scrollbar-thumb { background:#ccc; border-radius:3px; }
  .fc-msg-in { animation: fcIn .22s ease; }
  @keyframes fcIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  .fc-bot-row { display:flex; gap:7px; align-items:flex-start; }
  .fc-bot-icon {
    width:26px; height:26px; border-radius:8px; flex-shrink:0;
    background: linear-gradient(135deg,#111,#222);
    display:flex; align-items:center; justify-content:center; font-size:12px;
  }
  .fc-bot-bubble {
    background:#fff; border-radius:3px 12px 12px 12px;
    padding:9px 12px; font-size:13px; line-height:1.55; color:#1a1a1a;
    box-shadow:0 1px 5px rgba(0,0,0,.06); border:1px solid #e8e8e8;
    max-width:84%;
  }
  .fc-hint-bubble {
    margin-top:4px; background:#f0f0f0;
    border:1px solid #e0e0e0; border-radius:3px 10px 10px 10px;
    padding:7px 11px; font-size:11.5px; color:#444; line-height:1.5; max-width:84%;
  }
  .fc-user-row { display:flex; justify-content:flex-end; }
  .fc-user-bubble {
    background: linear-gradient(135deg,#1a1a1a,#2d2d2d);
    border-radius:12px 3px 12px 12px;
    padding:9px 12px; font-size:13px; color:#fff; max-width:80%; line-height:1.5;
  }
  .fc-options { display:flex; flex-wrap:wrap; gap:6px; padding-left:33px; margin-top:2px; }
  .fc-opt-btn {
    background:#fff; border:1.5px solid #1a1a1a; border-radius:18px;
    padding:5px 12px; font-size:12px; color:#1a1a1a;
    cursor:pointer; font-family:'Plus Jakarta Sans',sans-serif; font-weight:500;
    transition:all .15s; white-space:nowrap;
  }
  .fc-opt-btn:hover, .fc-opt-btn:active { background:#1a1a1a; color:#fff; }
  .fc-typing-row { display:flex; gap:7px; align-items:flex-start; }
  .fc-typing {
    background:#fff; border-radius:3px 12px 12px 12px;
    padding:10px 14px; display:flex; gap:4px; align-items:center;
    box-shadow:0 1px 5px rgba(0,0,0,.06); border:1px solid #e8e8e8;
  }
  .fc-typing span {
    width:6px; height:6px; border-radius:50%; background:#1a1a1a;
    animation: fcBounce 1.2s ease-in-out infinite;
  }
  .fc-typing span:nth-child(2){animation-delay:.2s}
  .fc-typing span:nth-child(3){animation-delay:.4s}
  @keyframes fcBounce{0%,80%,100%{transform:translateY(0);opacity:.35}40%{transform:translateY(-5px);opacity:1}}
  #fc-input-bar {
    padding:10px 11px; border-top:1px solid #ebebeb;
    background:#fff; display:flex; gap:7px; align-items:center; flex-shrink:0;
  }
  #fc-input {
    flex:1; padding:9px 12px; border:1.5px solid #e0e0e0; border-radius:11px;
    font-size:13px; font-family:'Plus Jakarta Sans',sans-serif; outline:none;
    color:#1a1a1a; background:#fafafa; transition:border .2s;
  }
  #fc-input:focus { border-color:#1a1a1a; }
  #fc-send {
    background:linear-gradient(135deg,#1a1a1a,#2d2d2d); border:none;
    border-radius:11px; width:38px; height:38px; flex-shrink:0;
    cursor:pointer; color:#fff; font-size:15px;
    display:flex; align-items:center; justify-content:center;
  }
`;

// ─── State ────────────────────────────────────────────────────────────────────
let step = "start";
let context = {};
let chatEnded = false;

// ─── Helpers ──────────────────────────────────────────────────────────────────
function goodbyeMsg() {
  const msgs = [
    "You're so welcome! 🌟 Stay stylish and have a great day! 😊",
    "Happy to help! 🎉 Enjoy your Flex Case! ✨",
    "Anytime! 💚 Have a wonderful day! 📱",
    "Of course! 😊 Pleasure chatting. Have a great one! 🌈",
  ];
  return msgs[Math.floor(Math.random() * msgs.length)];
}

function detectIntent(text) {
  const t = text.toLowerCase();
  if (/^fc\d+$/i.test(text.trim())) return "order_id_direct";
  if (/\b(thank|thanks|bye|goodbye|that.?s all|done|no more|nothing else|i.?m good|all good|ok thanks|okay thanks|cheers)\b/.test(t)) return "goodbye";
  if (/\b(offer|discount|free|buy 3|b3g1|get 1|apply offer|not applied|not working|promo)\b/.test(t)) return "offer";
  if (/\b(free ship|shipping free|free delivery|shipping charge|above 297|297)\b/.test(t)) return "free_shipping";
  if (/\b(cod|cash on delivery|partial.*cod|pay.*delivery|75 rupees|partial payment)\b/.test(t)) return "cod";
  if (/\b(track|tracking link|track.*order|shipment link)\b/.test(t)) return "tracking_link";
  if (/\b(case type|difference|which case|slim silicone|glass case|silicone case|compare case|best case|types of case|case.*differ)\b/.test(t)) return "case_types";
  if (/\b(contact|email|reach|support team|help)\b/.test(t)) return "contact";
  if (/\b(samsung|oneplus|oppo|vivo|redmi|realme|poco|motorola|nothing phone|iqoo|google pixel|iphone|available|do you have|case for)\b/.test(t)) return "check_model";
  if (/\b(supported phone|which phone|device support|all.*phone|all.*device|android)\b/.test(t)) return "device_compat";
  return null;
}

// ─── Fetch order ──────────────────────────────────────────────────────────────
async function fetchOrder(orderId) {
  try {
    const res = await fetch(`${PROXY_URL}?orderId=${encodeURIComponent(orderId)}`);
    const data = await res.json();
    if (!res.ok) return { error: data.error || "Order not found." };
    return data;
  } catch (e) {
    return { error: "Could not connect. Please try again." };
  }
}

// ─── Build order reply ────────────────────────────────────────────────────────
function buildOrderReply(orderData, phoneDigits) {
  if (orderData.last4Phone && phoneDigits && orderData.last4Phone !== phoneDigits) {
    step = "ask_order_id";
    context = {};
    return {
      text: "❌ The mobile number doesn't match our records for this order.\n\nPlease double-check and try again, or contact us at 📧 **flexcasesindia@gmail.com**",
      options: ["🔄 Try again", "📞 Contact support", "✅ Done"],
    };
  }
  const today = new Date();
  const created = new Date(orderData.createdAt);
  const diffDays = Math.floor((today - created) / (1000 * 60 * 60 * 24));
  const formattedDate = created.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  const fs = orderData.fulfillmentStatus;
  let text = "";
  let options = ["🚚 Tracking link", "📞 Contact support", "✅ Done, thanks!"];

  if (fs === "fulfilled") {
    text = `Great news! 🎉 Order **${orderData.orderId}** placed on **${formattedDate}** has been **shipped**!`;
    if (orderData.trackingUrl) {
      text += `\n\n📦 [Click here to track your order](${orderData.trackingUrl})`;
    } else {
      text += `\n\n📲 You'll receive the tracking link on your registered number via SMS!`;
    }
  } else if (diffDays <= 6) {
    text = `Your order **${orderData.orderId}** was placed on **${formattedDate}** (${diffDays} day${diffDays !== 1 ? "s" : ""} ago).\n\n✅ It's been **processed** and is on its way! Delivery takes **5–8 business days**. 📦🚚`;
  } else {
    text = `We sincerely apologise! 🙏\n\nOrder **${orderData.orderId}** was placed on **${formattedDate}** (${diffDays} days ago).\n\n⚠️ There's been a **delay from the delivery side**. Your order is coming ASAP!\n\nFor urgent help: 📧 **flexcasesindia@gmail.com**`;
    options = ["📞 Contact support", "🔄 Track another order", "✅ Done!"];
  }
  step = "main_menu";
  context = {};
  return { text, options };
}

// ─── Main reply engine ────────────────────────────────────────────────────────
async function getBotReply(userInput) {
  const t = userInput.toLowerCase().trim();
  const intent = detectIntent(userInput);

  // ── Global intents ──────────────────────────────────────────────────────────
  if (intent === "goodbye") {
    chatEnded = true; step = "ended";
    return { text: goodbyeMsg() };
  }
  if (intent === "offer" || t.includes("🎁")) {
    if (/not.*(apply|applied|working)|can.?t.*apply/.test(t)) {
      return { text: "💡 The **Buy 3 Get 1 Free** offer is only valid on **Prepaid orders**.\n\nSwitch to UPI, card, or net banking at checkout and it'll apply automatically! 🎉", options: ["🎁 All offers", "💳 COD options", "✅ Done!"] };
    }
    return { text: "🎁 **Current Offers:**\n\n**1. Buy 3 Get 1 Absolutely FREE** 🛍️\nAdd any 4 items (cases, suctions, wallets — any mix). The 4th is free!\n⚠️ Valid on **Prepaid orders only**.\n\n**2. Free Shipping above ₹297** 🚚\nOrder ₹297+ and delivery is completely free!", options: ["🛒 Shop now", "💳 COD options", "📦 My order", "✅ Done!"] };
  }
  if (intent === "free_shipping") {
    return { text: "🚚 Shipping is **free on all orders above ₹297**! Applied automatically at checkout.", options: ["🎁 All offers", "🛒 Shop now", "✅ Done!"] };
  }
  if (intent === "cod" || t.includes("💳")) {
    return { text: "Yes! We offer **Partial COD** 🙌\n\nPay just **₹75 now** and the rest on delivery.\n\n⚠️ Note: The Buy 3 Get 1 Free offer does **not** apply on COD orders.", options: ["🎁 Offers", "📦 My order", "✅ Done!"] };
  }
  if (intent === "tracking_link" || t.includes("🚚")) {
    return { text: "📲 You'll receive the **tracking link** on your registered number via **SMS** as soon as your order is shipped!", options: ["📦 My order status", "✅ Done!"] };
  }
  if (intent === "case_types" || t.includes("📱 case types")) {
    return {
      text: "We have **3 case types** 😊\n\n📱 **1. Slim Silicone Case**\nOur slimmest case — Anti-Yellow with **black sides**. Super slim fit!\n\n✨ **2. Glass Case** *(Most Popular!)*\nPremium **Glossy Glass** finish — the best of all 3! Anti-yellow, **black sides**, stunning look.\n\n🤍 **3. Silicone Case**\nClassic silicone with **transparent sides** — shows your phone's original colour!",
      options: ["📱 Check model availability", "🛒 Shop now", "✅ Done!"],
    };
  }
  if (intent === "contact" || t.includes("📞")) {
    return { text: "You can reach us at:\n\n📧 **flexcasesindia@gmail.com**\n\nWe respond within **24 hours**!", options: ["📦 My order", "🎁 Offers", "✅ Done!"] };
  }
  if (intent === "device_compat" || t.includes("📱 supported") || t.includes("supported phones")) {
    return { text: "We have cases for **all major devices** — Samsung, OnePlus, Oppo, Vivo, Realme, Redmi, Google Pixel & more! 📱\n\nJust displayed on iPhone for presentation. You can **select your model** while ordering.\n\n👉 [Browse all cases](https://flexcases.co.in/collections/all)", options: ["📱 Check model availability", "🛒 Shop now", "✅ Done!"] };
  }
  if (intent === "check_model" || t.includes("📱 check model")) {
    // Try to extract model directly from the message
    const result = checkModel(t);
    const keys = Object.keys(result);
    if (keys.length > 0) {
      const model = keys[0];
      const caseTypes = result[model];
      const caseStr = caseTypes.join(", ");
      return {
        text: `Great news! 🎉 **${model}** is available in:\n\n${caseTypes.map(c => `✅ **${c}**`).join("\n")}\n\n👉 [Order now](https://flexcases.co.in/collections/all)`,
        options: ["📱 Check another model", "🛒 Shop now", "✅ Done!"],
      };
    }
    // No model found in message — ask them
    step = "ask_model";
    return { text: "Sure! Which phone model are you looking for? 📱\n\nJust type the model name — e.g. *OnePlus 15*, *Samsung S24*, *iPhone 16*" };
  }

  // ── Conversation steps ──────────────────────────────────────────────────────
  if (step === "start") {
    step = "main_menu";
    return {
      text: "Hey there! 👋 Welcome to **Flex Cases** support!\n\nHow can I help you today?",
      options: ["📦 Where's my order?", "🎁 Current offers", "💳 COD / Partial COD", "📱 Case types", "📞 Contact support"],
    };
  }

  if (step === "ended") {
    step = "main_menu"; chatEnded = false;
    return { text: "Welcome back! 😊 What can I help you with?", options: ["📦 My order", "🎁 Offers", "📞 Contact support"] };
  }

  if (step === "ask_model") {
    step = "main_menu";
    const result = checkModel(t);
    const keys = Object.keys(result);
    if (keys.length > 0) {
      const model = keys[0];
      const caseTypes = result[model];
      return {
        text: `Great news! 🎉 **${model}** is available in:\n\n${caseTypes.map(c => `✅ **${c}**`).join("\n")}\n\n👉 [Order now](https://flexcases.co.in/collections/all)`,
        options: ["📱 Check another model", "🛒 Shop now", "✅ Done!"],
      };
    }
    return {
      text: `Hmm, I couldn't find **"${userInput}"** in our current catalogue. 🤔\n\nWe're constantly adding new models! Please check our website or contact us.\n\n📧 **flexcasesindia@gmail.com**`,
      options: ["📱 Check another model", "📞 Contact support", "✅ Done!"],
    };
  }

  if (step === "ask_order_id" || intent === "order_id_direct") {
    const input = userInput.trim().toUpperCase();
    if (!/^FC\d+$/.test(input)) {
      step = "ask_order_id";
      return { text: "That doesn't look right. 🤔\n\nYour Order ID should start with **FC** followed by numbers — e.g. **FC12345**.", hint: "💡 Check your confirmation SMS or email." };
    }
    context.orderId = input;
    step = "ask_verify_phone";
    return { text: `Got it — Order **${input}** 🔍\n\nTo protect your privacy, please enter the **last 4 digits** of the mobile number used while placing the order.` };
  }

  if (step === "ask_verify_phone") {
    const digits = userInput.trim().replace(/\D/g, "");
    if (digits.length !== 4) {
      return { text: "Please enter exactly the **last 4 digits** of your registered mobile number. E.g. **7894**" };
    }
    context.phoneDigits = digits;
    step = "fetching_order";
    return { text: `Verifying your details... ⏳`, loading: true };
  }

  if (step === "main_menu") {
    if (t.includes("order") || t.includes("📦")) {
      step = "ask_order_id";
      return { text: "Sure! Please share your **Order ID** 🔍", hint: "💡 Your Order ID starts with **FC** — e.g. **FC12345**. Find it in your confirmation SMS or email." };
    }
    if (t.includes("browse") || t.includes("shop") || t.includes("🛒")) {
      return { text: "Check out our collection! 🛍️\n\n👉 [flexcases.co.in](https://flexcases.co.in/collections/all)\n\nStarting at **₹199** + **Buy 3 Get 1 Free**! 🎁", options: ["🎁 Offer details", "✅ Done!"] };
    }
    if (t.includes("check another model") || t.includes("📱 check another")) {
      step = "ask_model";
      return { text: "Which phone model are you looking for? 📱\n\nType the model name — e.g. *OnePlus 15*, *Samsung S24*, *iPhone 16*" };
    }
    if (t.includes("track another") || t.includes("🔄")) {
      step = "ask_order_id";
      return { text: "Sure! Please share the **Order ID** you'd like to check.", hint: "💡 It starts with **FC** — e.g. **FC12345**" };
    }
    if (t.includes("done") || t.includes("✅") || t.includes("nothing") || t.includes("no ") || t.includes("i'm good")) {
      chatEnded = true; step = "ended";
      return { text: goodbyeMsg() };
    }
    return { text: "Here's what I can help you with 👇", options: ["📦 Where's my order?", "🎁 Current offers", "💳 COD / Partial COD", "📱 Case types", "📞 Contact support"] };
  }

  return { text: "Here's what I can help you with 👇", options: ["📦 Where's my order?", "🎁 Offers", "💳 COD", "📱 Case types", "📞 Contact support"] };
}

// ─── Render helpers ───────────────────────────────────────────────────────────
function mdToHtml(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\[(.+?)\]\((https?:\/\/.+?)\)/g, '<a href="$2" target="_blank" style="color:#1a1a1a;font-weight:600;text-decoration:underline">$1</a>')
    .replace(/\n/g, "<br>");
}

function makeBotBubble(text, hint) {
  const wrap = document.createElement("div");
  wrap.className = "fc-msg-in";
  const row = document.createElement("div");
  row.className = "fc-bot-row";
  const icon = document.createElement("div");
  icon.className = "fc-bot-icon"; icon.textContent = "📱";
  const inner = document.createElement("div"); inner.style.maxWidth = "84%";
  const bubble = document.createElement("div");
  bubble.className = "fc-bot-bubble";
  bubble.innerHTML = mdToHtml(text);
  inner.appendChild(bubble);
  if (hint) {
    const h = document.createElement("div");
    h.className = "fc-hint-bubble"; h.innerHTML = mdToHtml(hint);
    inner.appendChild(h);
  }
  row.appendChild(icon); row.appendChild(inner); wrap.appendChild(row);
  return wrap;
}

function makeUserBubble(text) {
  const wrap = document.createElement("div"); wrap.className = "fc-msg-in";
  const row = document.createElement("div"); row.className = "fc-user-row";
  const b = document.createElement("div"); b.className = "fc-user-bubble"; b.textContent = text;
  row.appendChild(b); wrap.appendChild(row); return wrap;
}

function makeOptions(opts) {
  const div = document.createElement("div"); div.className = "fc-options fc-msg-in";
  opts.forEach(opt => {
    const btn = document.createElement("button"); btn.className = "fc-opt-btn"; btn.textContent = opt;
    btn.addEventListener("click", () => handleMsg(opt));
    div.appendChild(btn);
  });
  return div;
}

function makeTyping() {
  const wrap = document.createElement("div"); wrap.className = "fc-msg-in fc-typing-row"; wrap.id = "fc-typing-indicator";
  const icon = document.createElement("div"); icon.className = "fc-bot-icon"; icon.textContent = "📱";
  const t = document.createElement("div"); t.className = "fc-typing";
  t.innerHTML = "<span></span><span></span><span></span>";
  wrap.appendChild(icon); wrap.appendChild(t); return wrap;
}

function scrollBottom() {
  const m = document.getElementById("fc-messages");
  if (m) m.scrollTop = m.scrollHeight;
}

// ─── Message handler ──────────────────────────────────────────────────────────
async function handleMsg(text) {
  const msgs = document.getElementById("fc-messages");
  if (!msgs) return;

  msgs.querySelectorAll(".fc-options").forEach(el => el.remove());

  if (text !== "__init__") {
    msgs.appendChild(makeUserBubble(text));
    scrollBottom();
  }

  const typing = makeTyping();
  msgs.appendChild(typing); scrollBottom();

  await new Promise(r => setTimeout(r, 750));

  const reply = await getBotReply(text);
  typing.remove();

  msgs.appendChild(makeBotBubble(reply.text, reply.hint || null));
  if (reply.options) msgs.appendChild(makeOptions(reply.options));
  scrollBottom();

  if (reply.loading && step === "fetching_order") {
    const t2 = makeTyping(); msgs.appendChild(t2); scrollBottom();
    const orderData = await fetchOrder(context.orderId);
    t2.remove();
    if (orderData.error) {
      step = "ask_order_id"; context = {};
      msgs.appendChild(makeBotBubble("❌ " + orderData.error + "\n\nPlease check your Order ID and try again."));
      msgs.appendChild(makeOptions(["🔄 Try again", "📞 Contact support"]));
    } else {
      const result = buildOrderReply(orderData, context.phoneDigits);
      msgs.appendChild(makeBotBubble(result.text));
      if (result.options) msgs.appendChild(makeOptions(result.options));
    }
    scrollBottom();
  }
}

// ─── Init ─────────────────────────────────────────────────────────────────────
function initChatbot() {
  const style = document.createElement("style");
  style.textContent = STYLES;
  document.head.appendChild(style);

  const fab = document.createElement("button");
  fab.id = "fc-chat-fab"; fab.textContent = "💬";
  fab.setAttribute("aria-label", "Open support chat");
  document.body.appendChild(fab);

  const win = document.createElement("div");
  win.id = "fc-chat-window";
  win.innerHTML = `
    <div id="fc-chat-header">
      <div class="fc-avatar">📱</div>
      <div>
        <div class="fc-hdr-title">Flex Support</div>
        <div class="fc-hdr-status">
          <div class="fc-dot"></div>
          <span class="fc-hdr-status-text">Online · Usually replies instantly</span>
        </div>
      </div>
      <button id="fc-chat-close" aria-label="Close chat">✕</button>
    </div>
    <div id="fc-messages"></div>
    <div id="fc-input-bar">
      <input id="fc-input" type="text" placeholder="Type a message..." autocomplete="off" />
      <button id="fc-send">➤</button>
    </div>
  `;
  document.body.appendChild(win);

  let isOpen = false;

  function openChat() {
    isOpen = true;
    win.classList.add("open"); fab.classList.add("open"); fab.textContent = "✕";
    if (document.getElementById("fc-messages").children.length === 0) {
      step = "start"; context = {}; chatEnded = false;
      handleMsg("__init__");
    }
    setTimeout(() => document.getElementById("fc-input").focus(), 200);
  }

  function closeChat() {
    isOpen = false;
    win.classList.remove("open"); fab.classList.remove("open"); fab.textContent = "💬";
  }

  fab.addEventListener("click", () => isOpen ? closeChat() : openChat());
  document.getElementById("fc-chat-close").addEventListener("click", closeChat);

  document.getElementById("fc-send").addEventListener("click", () => {
    const inp = document.getElementById("fc-input");
    const val = inp.value.trim();
    if (val) { inp.value = ""; handleMsg(val); }
  });

  document.getElementById("fc-input").addEventListener("keydown", e => {
    if (e.key === "Enter") {
      const val = e.target.value.trim();
      if (val) { e.target.value = ""; handleMsg(val); }
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initChatbot);
} else {
  initChatbot();
}